export enum CardType {
  Warning= 'warning',
  Info= 'info',
  Success= 'success'
}
export interface Card {
  type: CardType;
  title: string;
  summary: string;
  summaryIcon?: string;
  count: string;
  link_name: string;
  link: string;
  icon?: string;
}